// -didim_realty_world
import React from 'react';
import { Link } from 'react-router-dom';

interface TopInfoBarProps {
    phone?: string;
    email?: string;
    workingHours?: string;
}

const TopInfoBar: React.FC<TopInfoBarProps> = ({
    phone = '+90 542 123 45 67',
    email = 'info@didimrealty.com',
    workingHours = 'Mon-Sat: 09:00 - 18:00'
}) => {
    return (
        <div className="bg-secondary text-white py-2 px-4 text-xs md:text-sm">
            <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-2">
                <div className="flex items-center gap-6">
                    <a
                        className="flex items-center gap-2 hover:text-gray-300 transition-colors"
                        href={`tel:${phone.replace(/\s/g, '')}`}
                    >
                        <span className="material-symbols-outlined text-[18px]">call</span>
                        <span>{phone}</span>
                    </a>
                    <a
                        className="flex items-center gap-2 hover:text-gray-300 transition-colors hidden sm:flex"
                        href={`mailto:${email}`}
                    >
                        <span className="material-symbols-outlined text-[18px]">mail</span>
                        <span>{email}</span>
                    </a>
                </div>
                <div className="flex items-center gap-4">
                    <span className="flex items-center gap-1 cursor-pointer hover:text-gray-300">
                        <span className="material-symbols-outlined text-[18px]">schedule</span>
                        <span>{workingHours}</span>
                    </span>
                </div>
            </div>
        </div>
    );
};

export default TopInfoBar;
